import { createTheme } from '@material-ui/core/styles'
import { getProfileTheme } from 'services/colors'

// ╔╦╗╔═╗╔╦╗╔═╗╔╦╗╔═╗╔╦╗╔═╗
// ║║║║╣  ║ ╠═╣ ║║╠═╣ ║ ╠═╣
// ╩ ╩╚═╝ ╩ ╩ ╩═╩╝╩ ╩ ╩ ╩ ╩

export const colors = {
  notification: '#FF6767',
  background: '#F7F7F7',
  backgroundTable: '#F6F6F6',
  white: '#FFF',
  ...getProfileTheme(),
}

const theme = createTheme({
  palette: {
    primary: {
      main: colors.color500,
    },
    secondary: {
      main: colors.main,
    },
  },
  typography: {
    fontFamily: '"Roboto Slab", serif',
    h1: {
      fontWeight: 700,
      fontSize: '3rem',
    },
    h2: {
      fontWeight: 700,
      fontSize: '2.25rem',
    },
    h3: {
      fontWeight: 500,
      fontSize: '1.75rem',
    },
    h4: {
      fontWeight: 500,
      fontSize: '1.5rem',
    },
    h5: {
      fontWeight: 400,
      fontSize: '1.25rem',
    },
    h6: {
      fontWeight: 400,
      fontSize: '1rem',
    },
    body1: {
      fontWeight: 400,
      fontSize: '0.875rem',
    },
    body2: {
      fontWeight: 400,
      fontSize: '0.75rem',
    },
    button: {
      fontWeight: 700,
      textTransform: 'none',
    },
  },
})

export default theme
